import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { StarRatting } from "../../../../../../components";
function Feadback(props) {
  const {
    filters,
    setFilters,
    handleRatting,
    id,
    submitFeedback,
    request_type,
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    submitFeedback();
    document.getElementById("close-filter").click();
  };
  return (
    <>
      <div
        className="modal fade feedback"
        id="feedback"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="feedback-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-filter"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="feedback-title">
                  Feedback
                </h5>
                <div className="dark-grey-color small-font-size text-center">
                  Request #{id}
                </div>
                <p className="text-center sub-title pb-4 mb-3 pt-3">
                  How was your move?
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row pb-3">
                    <div className="col-12">
                      <div className="form-group">
                        <label
                          htmlFor="distance"
                          className="overline dark-grey-color"
                        >
                          Comments
                        </label>
                        <textarea
                          className="form-control small-font-size text-area"
                          placeholder="Please let the company Know what went great and what should be improved?"
                          value={filters.comments}
                          onChange={(e) =>
                            setFilters({ ...filters, comments: e.target.value })
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <label
                        htmlFor="distance"
                        className="overline dark-grey-color"
                      >
                        Rate
                      </label>
                      <div className="star-rating">
                        <StarRatting
                          ratting={filters.ratting}
                          handleRatting={handleRatting}
                        />
                      </div>
                    </div>
                  </div>
                  {/* tip */}
                  {!request_type && (
                    <>
                      <label
                        htmlFor="distance"
                        className="overline dark-grey-color"
                      >
                        If you liked the service you can leave some tips
                      </label>
                      <div className="price-buttons mb-3">
                        <a
                          onClick={() => setFilters({ ...filters, tip: 0 })}
                          style={{ minWidth: 63 }}
                          className={
                            filters.tip === 0
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button "
                          }
                        >
                          0%
                        </a>
                        <a
                          onClick={() => setFilters({ ...filters, tip: 12 })}
                          style={{ minWidth: 63 }}
                          className={
                            filters.tip === 12
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          12%
                        </a>
                        <a
                          onClick={() => setFilters({ ...filters, tip: 15 })}
                          style={{ minWidth: 63 }}
                          className={
                            filters.tip === 15
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          15%
                        </a>
                        <a
                          onClick={() => setFilters({ ...filters, tip: 20 })}
                          style={{ minWidth: 63 }}
                          className={
                            filters.tip === 20
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          20%
                        </a>
                        <a
                          onClick={() =>
                            setFilters({ ...filters, tip: "other" })
                          }
                          style={{ minWidth: 63 }}
                          className={
                            filters.tip === "other"
                              ? "custom-btn-small custom-button-extra-small filter-button mt-2 mt-sm-0 active"
                              : "custom-btn-small custom-button-extra-small filter-button mt-2 mt-sm-0"
                          }
                        >
                          other
                        </a>
                        <div className="clearfix"></div>
                      </div>
                    </>
                  )}
                  <div className="feedback-comment-box pt-3">
                    {filters.tip === "other" && (
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="form-group col-sm-6 ">
                          <label
                            htmlFor="distance"
                            className="overline dark-grey-color"
                          >
                            Tip amount
                          </label>
                          <NumberFormat
                            placeholder="$"
                            className="form-control small-font-size "
                            value={filters.tip_amount}
                            allowLeadingZeros
                            allowNegative={false}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                tip_amount: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-3"></div>
                      </div>
                    )}
                  </div>
                  {/* <div className="row justify-content-center pt-3 pb-5">
                    <div className="col-12 col-sm-10">
                      <button
                        type="submit"
                        className="red-btn custom-buton custom-buton-large w-100"
                      >
                        Leave Feedback
                      </button>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Feadback;
